import { render, staticRenderFns } from "./connections-overview-card.vue?vue&type=template&id=51e1b9cf&"
import script from "./connections-overview-card.vue?vue&type=script&lang=js&"
export * from "./connections-overview-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports